import { Location } from '@angular/common'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router'
import * as moment from 'moment'
import { Subscription } from 'rxjs'
import { NotificationService } from '../../../../notification/shared/notification.service'
import { CommandeService } from '../../../linge-hebergement/shared/commande.service'
import { LingerieService } from '../../../settings/commande-param/commande-param-settings/shared/lingerie.service'
import { Client } from '../../../shared/client/client'
import { ClientService } from '../../../shared/client/client.service'
import { ReturnValidationComponent } from './return-validation/return-validation.component'

@Component({
  selector: 'app-gestion-stats-LH',
  templateUrl: './gestion.component.html',
  styleUrls: ['./gestion.component.scss']
})
export class GestionComponent implements OnInit, OnDestroy {

  subClient: Subscription
  currentClient: Client
  listMois = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"]
  currentMonth = this.listMois[((new Date()).getMonth()) == 0 ? 11 : (new Date()).getMonth() - 1]
  currentYear = (new Date()).getFullYear()
  lastYear = (new Date()).getFullYear() - 1
  listAnnee = [this.currentYear, this.lastYear]
  statsLH
  control: FormGroup = new FormGroup({
    'annee': new FormControl(((new Date()).getMonth()) == 0 ? this.lastYear : this.currentYear),
    'mois': new FormControl(this.currentMonth)
  })
  loading: Boolean = false
  isLingerie: Boolean = false
  lingeries
  isSante: Boolean = false
  isHotel: Boolean = false
  changeNotSave = false;

  constructor(
    private clientService: ClientService,
    private commandeService: CommandeService,
    private router: Router,
    private notificationService: NotificationService,
    private lingerieService: LingerieService,
    private _location: Location,
    private dialog: MatDialog
  ) {
    moment().locale('fr')
  }


  ngOnInit(): void {
    // Récupération des activités pour le client
    // Récupération des années disponibles (forcément année en cours)
    this.subClient = this.clientService.getCurrentClient().subscribe(client => {
      this.currentClient = client
      if (this.currentClient != null) {
        this.isLingeHebergementActivated()
        this.isLingerie = this.currentClient.is_comptage_lingerie || !this.currentClient.is_livraison_commande

        this.isSante = (this.currentClient.famille_client.cle_ref == '700' || this.currentClient.famille_client.parent?.cle_ref == '700')
        this.isHotel = (this.currentClient.famille_client.cle_ref == '600' || this.currentClient.famille_client.parent?.cle_ref == '600')

        if (this.isLingerie) {
          this.getLingeries()
        }
        this.getStatsLH(this.currentClient)
      }
    })
  }

  ngOnDestroy() {
    if (this.subClient) {
      this.subClient.unsubscribe()
    }
  }

  getStatsLH(client) {
    this.commandeService.getClientStatsLH(client.id).subscribe(data => {
      this.statsLH = data
      this.statsLH.forEach(data => {
        if (this.listAnnee.indexOf(data.annee) == -1) {
          this.listAnnee.push(data.annee)
        }
      })
    })
  }

  /**
   * Met à jour les statistiques modifiées de linge d'hébergement
   * @param mois 
   * @param event 
   * @param isDataJour 
   */
  update(mois, event, isDataJour) {
    this.changeNotSave = true;
    if (event.target.value == "" || (isDataJour && event.target.value && Number(event.target.value) > this.getNbJoursMois(mois))) {
      event.target.value = this.getNbJoursMois(mois)
    }

    if (event.target.value && event.target.value < 0) {
      event.target.value = 0
    }

    let index = this.statsLH.findIndex(data =>
      data.annee == this.control.value.annee &&
      data.mois == this.listMois.indexOf(mois) + 1
    )
    if (index == -1) {
      this.statsLH.push({
        mois: this.listMois.indexOf(mois) + 1,
        annee: this.control.value.annee,
        nb_jours: isDataJour ? (event.target.value ? Number(event.target.value) : null) : null,
        nb_emplacements: !isDataJour ? (event.target.value ? Number(event.target.value) : null) : null
      })
    } else {
      if (isDataJour) {
        this.statsLH[index].nb_jours = event.target.value ? Number(event.target.value) : null
      } else {
        this.statsLH[index].nb_emplacements = event.target.value ? Number(event.target.value) : null
      }
    }
  }

  /**
   * Met à jour les statistiques modifiées de linge d'hébergement pour la lingerie
   * @param idLingerie 
   * @param event 
   * @param isDataJour 
   */
  updateLingerie(idLingerie, event, isDataJour) {
    this.changeNotSave = true;
    if (isDataJour && (event.target.value == "" || (event.target.value && Number(event.target.value) > this.getNbJoursMois(this.control.value.mois)))) {
        event.target.value = this.getNbJoursMois(this.control.value.mois)
    }

    if (event.target.value && event.target.value < 0) {
      event.target.value = 0
    }

    let index = this.statsLH.findIndex(data =>
      data.annee == this.control.value.annee &&
      data.mois == this.listMois.indexOf(this.control.value.mois) + 1 &&
      data.lingerie.id == idLingerie
    )

    if (index == -1) {
      this.statsLH.push({
        lingerie: this.lingeries.find(lingerie => lingerie.id == idLingerie),
        mois: this.listMois.indexOf(this.control.value.mois) + 1,
        annee: this.control.value.annee,
        nb_jours: isDataJour ? (event.target.value ? Number(event.target.value) : null) : null,
        nb_emplacements: !isDataJour ? (event.target.value ? Number(event.target.value) : null) : null
      })
    } else {
      if (isDataJour) {
        this.statsLH[index].nb_jours = event.target.value ? Number(event.target.value) : null
      } else {
        this.statsLH[index].nb_emplacements = event.target.value ? Number(event.target.value) : null
      }
    }
  }

  saveStatsLH() {
    this.loading = true;
    this.commandeService.postClientStatsLH(this.currentClient.id, this.statsLH).subscribe(data => {
      this.notificationService.notif("Les données statistiques du linge d'hébergement mises à jour ont été enregistrées.", 'notif')
      this.router.navigate(['/escli/statistic/linge-hebergement'])
      this.loading = false
    }, error => this.loading = false)
  }

  refuse() {
    if (this.changeNotSave) {
      const dialogRef = this.dialog.open(ReturnValidationComponent);
      dialogRef.afterClosed().subscribe(result => {
        if (result === true) {
          this.router.navigate(['/escli/statistic/linge-hebergement'])
        }
      });
    } else {
      this.router.navigate(['/escli/statistic/linge-hebergement'])
    }
  }

  getLingeries() {
    this.lingerieService.getLingeriesClient(this.currentClient.id).subscribe(data => {
      this.lingeries = data.sort((a, b) => a.libelle > b.libelle ? 1 : -1)
      this.loading = false
    })
  }

  getHistorique() {
    this.router.navigate(['/escli/statistic/stats-LH/historique'])
  }

  /**
   * Récupérer les jours d'activités / nuitées du mois
   * @param mois 
   * @returns jours d'activités / nuitées pour le mois
   */
  getJours(mois) {
    if (this.statsLH) {
      let data = this.statsLH.find(el =>
        el.annee == this.control.value.annee &&
        el.mois == this.listMois.indexOf(mois) + 1
      )
      return data ? data.nb_jours ?? this.getNbJoursMois(mois) : this.getNbJoursMois(mois)
    } else {
      return this.getNbJoursMois(mois)
    }
  }

  getEmplacements(mois) {
    if (this.statsLH) {
      let data = this.statsLH.find(el =>
        el.annee == this.control.value.annee &&
        el.mois == this.listMois.indexOf(mois) + 1
      )
      return data ? data.nb_emplacements : null
    } else {
      return null
    }
  }

  /**
   * Récupérer les jours d'activités / nuitées pour la lingerie (mois/annee)
   * @param mois 
   * @returns jours d'activités / nuitées pour la lingerie (mois/annee)
   */
  getJoursLingerie(idLingerie) {
    if (this.statsLH) {
      let data = this.statsLH.find(el =>
        el.annee == this.control.value.annee &&
        el.mois == this.listMois.indexOf(this.control.value.mois) + 1 &&
        el.lingerie.id == idLingerie
      )
      return data ? data.nb_jours ?? this.getNbJoursMois(this.control.value.mois) : this.getNbJoursMois(this.control.value.mois)
    } else {
      return this.getNbJoursMois(this.control.value.mois)
    }
  }

  getEmplacementsLingerie(idLingerie) {
    if (this.statsLH) {
      let data = this.statsLH.find(el =>
        el.annee == this.control.value.annee &&
        el.mois == this.listMois.indexOf(this.control.value.mois) + 1 &&
        el.lingerie.id == idLingerie
      )
      return data ? data.nb_emplacements : null
    } else {
      return null
    }
  }

  /**
   * Récupération du nombre de jours du mois
   * @param mois 
   * @returns nombre de jours dans le mois
   */
  getNbJoursMois(mois) {
    mois = this.listMois.indexOf(mois) + 1
    return new Date(this.control.value.annee, mois, 0).getDate()
  }

  isLingeHebergementActivated() {
    if (!this.currentClient.is_livraison_commande || this.currentClient.is_comptage_lingerie) {
      this.commandeService.getClientDotations(this.currentClient.id).subscribe(data => {
        if (data.length == 0) {
          this.router.navigate(['/escli/statistic/linge-hebergement']).then(() => {
            this.notificationService.notif(
              "Le linge d'hébergement n'est pas activé pour le compte client sélectionné",
              "warn"
            )
          })
        }
      })
    } else {
      let value = (this.currentClient.is_livraison_commande && !this.currentClient.is_comptage_lingerie)
      if (!value) {
        this.router.navigate(['/escli/statistic/linge-hebergement']).then(() => {
          this.notificationService.notif(
            "Le linge d'hébergement n'est pas activé pour le compte client sélectionné",
            "warn"
          )
        })
      }
    }
  }
}
